import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'component/Select/Select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class VersionSelect extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    fillVersions: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      versions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user } = this.props

    this.setState({ loading: true })

    return new Api(user.dsToken)
      .get(API_URL.VERSION_LIST)
      .then((response) => this.onFetchSuccess(response.data))
      .catch((error) => this.onFetchError(error))
  }

  onFetchSuccess(versions) {
    this.setState({
      versions: [
      
        ...versions,
      ].map(({ idVersion }, index) => ({ label: idVersion, value: index })),
      loading: false,
      error: null,
    })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, versions: [] })
  }

  render() {
    const { value, onChange, translate, disabled } = this.props
    const { versions, loading } = this.state
    const placeholder = loading
      ? translate('loading')
      : translate('mobile.update.download.apk.version.select')

    return (
      <Select
        label={translate('mobile.update.download.apk.version')}
        options={versions}
        placeholder={placeholder}
        translate={translate}
        onChange={onChange}
        value={versions.find((option) => option.label === value)}
        required
        containerClass='text-align-left-no-color margin-top'
        fill
        disabled={disabled}
        validateValue={(v) => Boolean(v)}
      />
    )
  }
}

export default VersionSelect
